import { bulkRemoveNotifications, bulkMarkAsRead } from '@api/notifications';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from '@ui/components';
import { useState } from 'react';

export const useNotificationsBulkActions = ({
  onNotificationMarkAsReadSuccess,
  onNotificationRemoveSuccess,
}: {
  onNotificationMarkAsReadSuccess: () => void;
  onNotificationRemoveSuccess: () => void;
}) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const { mutate: bulkEditEmployeesDeleteMutation, isPending: isPendingDelete } = useMutation({
    mutationFn: (notificationIds: string[]) => bulkRemoveNotifications(notificationIds),
    onSuccess: () => {
      setIsDeleteOpen(false);
      queryClient.invalidateQueries({ queryKey: ['notifications-table'] });
      queryClient.invalidateQueries({ queryKey: ['notifications-count'] });
      toast.success(t('NOTIFICATIONS.BULK_DELETE_DIALOG_SUCCESS'));
      onNotificationRemoveSuccess();
    },
    onError: () => {
      toast.error(t('API_ERRORS.DEFAULT'));
    },
  });

  const { mutate: bulkEditEmployeesMarkAsReadMutation, isPending: isPendingMarkAsRead } =
    useMutation({
      mutationFn: (notificationIds: string[]) => bulkMarkAsRead(notificationIds),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['notifications-table'] });
        queryClient.invalidateQueries({ queryKey: ['notifications-count'] });
        toast.success(t('NOTIFICATIONS.BULK_MARK_AS_READ_DIALOG_SUCCESS'));
        onNotificationMarkAsReadSuccess();
      },
      onError: () => {
        toast.error(t('API_ERRORS.DEFAULT'));
      },
    });

  return {
    bulkEditEmployeesMarkAsReadMutation,
    bulkEditEmployeesDeleteMutation,
    isPendingMarkAsRead,
    setIsDeleteOpen,
    isPendingDelete,
    isDeleteOpen,
  };
};
